export default __webpack_public_path__ + "static/rec-2024-iii-5200e5a6d55a94691271f10217d7df7b.jpeg";